module.exports = __webpack_public_path__ + "img/LTS_KPMG_k.60c5225b.gif";